import CLIENT from '../utils/restClient';
import Logger, { LOG_LEVELS } from '../utils/logger';

export const MODULE_NAME = 'DATA_MINING_MODULE';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
function namespaced(name) {
    return MODULE_NAME + '.' + name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_INTRA = namespaced('LOAD_INTRA');
const LOAD_INTRA_OK = namespaced('LOAD_INTRA_OK');
const LOAD_INTRA_FAIL = namespaced('LOAD_INTRA_FAIL');
const LOAD_CHANGESLOG = namespaced('LOAD_CHANGESLOG');
const LOAD_CHANGESLOG_OK = namespaced('LOAD_CHANGESLOG_OK');
const LOAD_CHANGESLOG_FAIL = namespaced('LOAD_CHANGESLOG_FAIL');
const LOAD_DELETELOG = namespaced('LOAD_DELETELOG');
const LOAD_DELETELOG_OK = namespaced('LOAD_DELETELOG_OK');
const LOAD_DELETELOG_FAIL = namespaced('LOAD_DELETELOG_FAIL');
const LOAD_REPCOMBHIST = namespaced('LOAD_REPCOMBHIST');
const LOAD_REPCOMBHIST_OK = namespaced('LOAD_REPCOMBHIST_OK');
const LOAD_REPCOMBHIST_FAIL = namespaced('LOAD_REPCOMBHIST_FAIL');
const LOAD_GLSTATUS = namespaced('LOAD_GLSTATUSVR');
const LOAD_GLSTATUS_OK = namespaced('LOAD_GLSTATUSVR_OK');
const LOAD_GLSTATUS_FAIL = namespaced('LOAD_GLSTATUSVR_FAIL');
const GLRECONCILING = namespaced('GLRECONCILING');
const GLRECONCILIATION_OK = namespaced('GLRECONCILIATION_OK');
const GLRECONCILIATION_FAIL = namespaced('GLRECONCILIATION_FAIL');
const LOAD_FILEPROCESSINGDOCUMENTS = namespaced('LOAD_FILEPROCESSINGDOCUMENTS');
const LOAD_FILEPROCESSINGDOCUMENTS_OK = namespaced('LOAD_FILEPROCESSINGDOCUMENTS_OK');
const LOAD_FILEPROCESSINGDOCUMENTS_FAIL = namespaced('LOAD_FILEPROCESSINGDOCUMENTS_FAIL');
const LOAD_SII_TRANSACTIONS = namespaced('SII_TRANSACTIONS');
const LOAD_SII_TRANSACTIONS_OK = namespaced('SII_TRANSACTIONS_OK');
const LOAD_SII_TRANSACTIONS_FAIL = namespaced('SII_TRANSACTIONS_FAIL');
const CLEAR_ALL_REPORTS = namespaced('CLEAR_ALL_REPORTS');
const LOAD_SIILOG = namespaced('LOAD_SIILOG');
const LOAD_SIILOG_OK = namespaced('LOAD_SIILOG_OK');
const LOAD_SIILOG_FAIL = namespaced('LOAD_SIILOG_FAIL');
const UNLOAD = namespaced('UNLOAD');
const UNLOAD_GLSTATUS = namespaced('UNLOAD_GLSTATUS');
const UNLOAD_SII_TRANSACTIONS = namespaced('UNLOAD_SII_TRANSACTIONS');
const EXPORT_ALL = namespaced('EXPORT_ALL');
const EXPORT_ALL_OK = namespaced('EXPORT_ALL_OK');
const EXPORT_ALL_ELR_OK = namespaced('EXPORT_ALL_ELR_OK');
const EXPORT_ALL_FAIL = namespaced('EXPORT_ALL_FAIL');

// For now we are overloading the use of UPDATE to include delete too.
export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    LOAD_INTRA,
    LOAD_INTRA_OK,
    LOAD_INTRA_FAIL,
    LOAD_CHANGESLOG,
    LOAD_CHANGESLOG_OK,
    LOAD_CHANGESLOG_FAIL,
    LOAD_DELETELOG,
    LOAD_DELETELOG_OK,
    LOAD_DELETELOG_FAIL,
    LOAD_REPCOMBHIST,
    LOAD_REPCOMBHIST_OK,
    LOAD_REPCOMBHIST_FAIL,
    LOAD_GLSTATUS,
    LOAD_GLSTATUS_OK,
    LOAD_GLSTATUS_FAIL,
    GLRECONCILING,
    GLRECONCILIATION_OK,
    GLRECONCILIATION_FAIL,
    LOAD_FILEPROCESSINGDOCUMENTS,
    LOAD_FILEPROCESSINGDOCUMENTS_OK,
    LOAD_FILEPROCESSINGDOCUMENTS_FAIL,
    CLEAR_ALL_REPORTS,
    LOAD_SII_TRANSACTIONS,
    LOAD_SII_TRANSACTIONS_OK,
    LOAD_SII_TRANSACTIONS_FAIL,
    LOAD_SIILOG,
    LOAD_SIILOG_OK,
    LOAD_SIILOG_FAIL,
    UNLOAD,
    UNLOAD_GLSTATUS,
    UNLOAD_SII_TRANSACTIONS,
    EXPORT_ALL,
    EXPORT_ALL_OK,
    EXPORT_ALL_ELR_OK,
    EXPORT_ALL_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = { data: undefined, loading: false, error: null, uploading: false }, action) => {
    log.debug('actionHandler: ', action, state);
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return Object.assign({}, state, { invoiceLinesOnly: undefined, loading: true, error: null });
            case LOAD_OK:
                return Object.assign({}, state, { invoiceLinesOnly: action.response, loading: false, error: null });
            case LOAD_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLinesOnly: undefined, loading: false, error: action.error });
            case LOAD_INTRA:
                return Object.assign({}, state, { intrastatLines:undefined, loading: true, error: null });
            case LOAD_INTRA_OK:
                return Object.assign({}, state, { intrastatLines: action.response, loading: false, error: null });
            case LOAD_INTRA_FAIL:
                return Object.assign({}, state, { data: undefined, intrastatLines: undefined, loading: false, error: action.error });
            case LOAD_CHANGESLOG:
                return Object.assign({}, state, { loading: true, error: null });
            case LOAD_CHANGESLOG_OK:
                return Object.assign({}, state, { invoiceLines: action.response, loading: false, error: null });
            case LOAD_CHANGESLOG_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLines: undefined, loading: false, error: action.error });
            case LOAD_DELETELOG:
                return Object.assign({}, state, { deleteLog: undefined, loading: true, error: null });
            case LOAD_DELETELOG_OK:
                return Object.assign({}, state, { deleteLog: action.response, loading: false, error: null });
            case LOAD_DELETELOG_FAIL:
                return Object.assign({}, state, { data: undefined, deleteLog: undefined, loading: false, error: action.error });
            case LOAD_REPCOMBHIST:
                return Object.assign({}, state, { loading: true, error: null });
            case LOAD_REPCOMBHIST_OK:
                return Object.assign({}, state, { invoiceLines: action.response, loading: false, error: null });
            case LOAD_REPCOMBHIST_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLines: undefined, loading: false, error: action.error });
            case LOAD_GLSTATUS:
                return Object.assign({}, state, { loading: true, error: null });
            case LOAD_GLSTATUS_OK:
                return Object.assign({}, state, { invoiceLines: action.response, loading: false, error: null });
            case LOAD_GLSTATUS_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLines: undefined, loading: false, error: action.error });
            case GLRECONCILING:
                return Object.assign({}, state, { loading: true, error: null });
            case GLRECONCILIATION_OK:
                return Object.assign({}, state, { invoiceLines: {}, loading: false, error: null });
            case GLRECONCILIATION_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLines: undefined, loading: false, error: action.error });
            case LOAD_FILEPROCESSINGDOCUMENTS:
                return Object.assign({}, state, { loading: true, error: null });
            case LOAD_FILEPROCESSINGDOCUMENTS_OK:
                return Object.assign({}, state, { invoiceLines: action.response, loading: false, error: null });
            case LOAD_FILEPROCESSINGDOCUMENTS_FAIL:
                return Object.assign({}, state, { data: undefined, invoiceLines: undefined, loading: false, error: action.error });
            case LOAD_SII_TRANSACTIONS:
                return Object.assign({}, state, { loading: true, error: null});
            case LOAD_SII_TRANSACTIONS_OK:
                return Object.assign({}, state, { siiTransactions: action.response, loading: false, error: null });
            case LOAD_SII_TRANSACTIONS_FAIL:
                return Object.assign({}, state, { loading: false, error: action.error });
            case LOAD_SIILOG:
                return Object.assign({}, state, { siiLogData: undefined, loading: true, error: null });
            case LOAD_SIILOG_OK:
                return Object.assign({}, state, { siiLogData: action.response, loading: false, error: null });
            case LOAD_SIILOG_FAIL:
                return Object.assign({}, state, { data: undefined, siiLogData: undefined, loading: false, error: action.error });
            case UNLOAD:
                return Object.assign({}, state, { invoiceLinesOnly: undefined, loading: false, error: null });
            case UNLOAD_GLSTATUS:
                return Object.assign({}, state, { invoiceLines: undefined, loading: false, error: null });
            case UNLOAD_SII_TRANSACTIONS:
                return Object.assign({}, state, { siiTransactions: undefined, loading: false, error: null });
            case CLEAR_ALL_REPORTS:
                return Object.assign({}, state, {
                    invoiceLinesOnly: undefined,
                    invoiceLines: undefined,
                    intrastatLines: undefined,
                    deleteLog: undefined,
                    siiLogData: undefined,
                    siiTransactions: undefined,
                    loading: false, error: undefined });
            case EXPORT_ALL:
                return Object.assign({}, state, { showToast: false, showToastElr:false, error: null });
            case EXPORT_ALL_OK:
                return Object.assign({}, state, { showToast: true, showToastElr:false, error: null, exportResponse: action.response });
            case EXPORT_ALL_ELR_OK:
                return Object.assign({}, state, { showToast: false, showToastElr: true, error: null, exportResponse: action.response });
            case EXPORT_ALL_FAIL:
                return Object.assign({}, state, { showToast: false, showToastElr:false, error: action.error });

            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('actionHandler:  newState', newState);
    return newState;
};

export const API = {
    doGetInvoiceLinesData: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD });
            return CLIENT.getInvoiceLinesData(params)
                .then((response) => {
                    log.debug('getInvoiceLinesData success');
                    dispatch({ type: LOAD_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getInvoiceLinesData error');
                    dispatch({ type: LOAD_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doUnloadInvoiceLinesData: () => {
        return (dispatch, getState) => {
            dispatch({type: UNLOAD});
        };
    },
    doClearDataForAllReports: () => {
        return (dispatch, getState) => {
            dispatch({ type: CLEAR_ALL_REPORTS });
        };
    },
    doGetIntrastatLinesData: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_INTRA });
            return CLIENT.getIntrastatLinesData(params)
                .then((response) => {
                    log.debug('getIntrastatLinesData success');
                    dispatch({ type: LOAD_INTRA_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getIntrastatLinesData error');
                    dispatch({ type: LOAD_INTRA_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doGetChangesLog: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_CHANGESLOG });
            return CLIENT.getChangesLog(params)
                .then((response) => {
                    log.debug('getChangesLog success');
                    dispatch({ type: LOAD_CHANGESLOG_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getChangesLog error');
                    dispatch({ type: LOAD_CHANGESLOG_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doGetDeleteLogData: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_DELETELOG });
            return CLIENT.getDeleteLogData(params)
                .then((response) => {
                    log.debug('getDeleteLogData success');
                    dispatch({ type: LOAD_DELETELOG_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getDeleteLogData error');
                    dispatch({ type: LOAD_DELETELOG_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doGetVAtCodesHistory: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_REPCOMBHIST });
            return CLIENT.getVAtCodesHistory(params)
                .then((response) => {
                    log.debug('getVAtCodesHistory success');
                    dispatch({ type: LOAD_REPCOMBHIST_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getVAtCodesHistory error');
                    dispatch({ type: LOAD_REPCOMBHIST_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doGetGLStatusOverviewData: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_GLSTATUS });
            return CLIENT.getGLStatusOveriewData(params)
                .then((response) => {
                    log.debug('getGLStatusOveriewData success');
                    dispatch({ type: LOAD_GLSTATUS_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getGLStatusOveriewData error');
                    dispatch({ type: LOAD_GLSTATUS_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doUnloadGLData: () => {
        return (dispatch, getState) => {
            dispatch({type: UNLOAD_GLSTATUS});
        };
    },
    doGLReconciliation: (callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: GLRECONCILING });
            return CLIENT.doGLReconciliation()
                .then((response) => {
                    log.debug('doGLReconciliation success');
                    dispatch({ type: GLRECONCILIATION_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('doGLReconciliation error');
                    dispatch({ type: GLRECONCILIATION_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doGetProcessedDocumentData: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_FILEPROCESSINGDOCUMENTS });
            return CLIENT.getProcessedDocumentData(params)
                .then((response) => {
                    log.debug('doGetProcessedDocumentData success');
                    dispatch({ type: LOAD_FILEPROCESSINGDOCUMENTS_OK, response: response });
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('doGetProcessedDocumentData error');
                    dispatch({ type: LOAD_FILEPROCESSINGDOCUMENTS_FAIL, error });
                    callback(error, null);
                });
        }
    },
    getSIITransactions: (params, callback = ()=> {}) => {
        return (dispatch) => {
            dispatch({ type: LOAD_SII_TRANSACTIONS });
            return CLIENT.getSIITransactions(params)
              .then((response) => {
                log.debug('getSIITransactions: success:  ', response);
                dispatch( {type: LOAD_SII_TRANSACTIONS_OK, response: response});
                callback(null, response);
              })
              .catch((error) => {
                  log.debug('getSIITransactions error');
                  dispatch({type: LOAD_SII_TRANSACTIONS_FAIL, error});
                  callback(error, null)
              })
        }
    },
    doUnloadSIITransactions: () => {
        return (dispatch, getState) => {
            dispatch({type: UNLOAD_SII_TRANSACTIONS});
        };
    },
    getSIILog: (params, callback = () => { }) => {
        return (dispatch, getState) => {
            dispatch({ type: LOAD_SIILOG });
            return CLIENT.getSIILog(params)
                .then((response) => {
                    log.debug('getSIILog success');
                    dispatch({ type: LOAD_SIILOG_OK, response: response});
                    callback(null, response);
                })
                .catch((error) => {
                    log.debug('getSIILog error');
                    dispatch({ type: LOAD_SIILOG_FAIL, error });
                    callback(error, null);
                });
        }
    },
    doExportAllToCSV: (params) => {
        return (dispatch) => {
            dispatch({ type: EXPORT_ALL });
            return CLIENT.exportAllToCSV(params)
                .then((response) => {
                    log.debug('doExportAllToCSV success');
                    dispatch({ type: EXPORT_ALL_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doExportAllToCSV error');
                    dispatch({ type: EXPORT_ALL_FAIL, error });
                });
        }
    },
    doExportAllElrToCSV: (params) => {
        return (dispatch) => {
            dispatch({ type: EXPORT_ALL });
            return CLIENT.exportAllToCSV(params)
                .then((response) => {
                    log.debug('doExportAllElrToCSV success');
                    dispatch({type: EXPORT_ALL_ELR_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doExportAllElrToCSV error');
                    dispatch({ type: EXPORT_ALL_FAIL, error });
                });
        }
    },
    deResetExportAllToast: () => {
        return (dispatch) => {
            return new Promise((resolve) => {
                dispatch({ type: EXPORT_ALL });
                resolve();
            })
        }
    }
};

export default API;

